<template>
	<div class="container mb-4">
		<div class="row mt-5">
            <div class="col-12 text-center">
                <h1>Services</h1>
                <hr class="header-underline">
            </div>
        </div>
		<div class="row mt-4">
			<div class="col-lg-4 text-center mt-lg-1 mt-5">
				<img class="w-50 mb-3" src="../assets/api-design.png" />
				<h3>API Design</h3>
			</div>
			<div class="col-lg-4 text-center mt-lg-1 mt-5">
				<img class="w-50 mb-3" src="../assets/databasing-icon.png" />
				<h3>Databasing</h3>
			</div>
			<div class="col-lg-4 text-center mt-lg-1 mt-5">
				<img class="w-50 mb-3" src="../assets/design-icon.png" />
				<h3>Web</h3>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>
